import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { ScheduleActionFormData } from "./types";

type CopyToAnotherDayProps = {
    control: Control<ScheduleActionFormData>;
    isWeekModeActive: boolean;
};

const weekDays = [
    { value: "same", label: "Mesmo dia" },
    { value: 1, label: "Segunda-Feira" },
    { value: 2, label: "Terça-Feira" },
    { value: 3, label: "Quarta-Feira" },
    { value: 4, label: "Quinta-Feira" },
    { value: 5, label: "Sexta-Feira" },
    { value: 6, label: "Sabado" },
    { value: 0, label: "Domingo" },
] as const;

export const CopyToAnotherDay = ({ control, isWeekModeActive }: CopyToAnotherDayProps) => {
    return (
        <Controller
            name="selectedDays"
            control={control}
            render={({ field }) => (
                <FormControl fullWidth size="small" disabled={isWeekModeActive}>
                    <InputLabel id="copy-to-day-label">Copiar para dias</InputLabel>
                    <Select
                        labelId="copy-to-day-label"
                        multiple
                        value={field.value}
                        onChange={(e) => field.onChange(e.target.value as Array<number | "same">)}
                        label="Copiar para dias"
                        renderValue={(selected) => selected.map((day) => weekDays.find((d) => d.value === day)?.label).join(", ")}
                    >
                        {weekDays.map((day) => (
                            <MenuItem key={day.value} value={day.value}>
                                {day.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        />
    );
};
